import { z } from 'zod';

import { HttpClient } from '~/src/clients/http/HttpClient';

import { djangoHttpClient } from '../clients/shippo/DjangoHttpClient';

const BILLING_ACCOUNT_SCHEMA = z.object({
  billing_account_id: z.string(),
  billing_email: z.string().nullable(),
  grace_period_eligible: z.boolean(),
  grace_period_end_timestamp: z.string().nullable(),
  should_show_credit_expiration_message: z.boolean(),
});

export type BillingAccount = z.infer<typeof BILLING_ACCOUNT_SCHEMA>;

export class BillingAccountService {
  get = async (): Promise<BillingAccount> => {
    const { body } = await this.httpClient.get<BillingAccount>({
      url: '/billing/api/billing-account',
    });

    const billingAccount = BILLING_ACCOUNT_SCHEMA.parse(body);

    return billingAccount;
  };

  updateBillingEmail = async (billing_email: string) => {
    const response = await this.httpClient.put<void>({
      body: {
        billing_email,
      },
      url: '/billing/api/billing-account/email',
    });

    return response;
  };

  updateShouldShowCreditExpirationMessage = async () => {
    const response = await this.httpClient.put<void>({
      body: {
        should_show_credit_expiration_message: false,
      },
      headers: {},
      url: '/billing/api/billing-account/should-show-credit-expiration-message',
    });
    return response;
  };

  constructor(private readonly httpClient: HttpClient = djangoHttpClient) {}
}

export const billingAccountService = new BillingAccountService();
